/* 8月DAY施策：エッジキャッシュ対策
   Liquidが埋めた日付と、閲覧者の実時刻(JST)がズレていたら本日価格を隠す。
   キャッシュされた前日のページで古いDAY価格が出るのを防ぐ。 */
(function () {
  function jstToday() {
    var d = new Date();
    var jst = new Date(d.getTime() + (d.getTimezoneOffset() * 60000) + 9 * 3600000);
    return jst.getFullYear() + '-' +
      String(jst.getMonth() + 1).padStart(2, '0') + '-' +
      String(jst.getDate()).padStart(2, '0');
  }
  function effToday() {
    // PINK DAY前倒しOPEN：8/15 23:59以降は8/16として扱う（Liquid側と同じルール）
    var d = new Date();
    var j = new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 9 * 3600000);
    if (jstToday() === '2026-08-15' && j.getHours() === 23 && j.getMinutes() >= 59) {
      return '2026-08-16';
    }
    return jstToday();
  }
  function sync() {
    var today = effToday();
    document.querySelectorAll('.day-deal[data-day-date]').forEach(function (el) {
      el.hidden = el.dataset.dayDate !== today;
    });
  }
  document.addEventListener('DOMContentLoaded', sync);
  sync();
  // 日付をまたぐ滞在に備えて1分ごとに再判定
  setInterval(sync, 60000);
})();
